import { render } from "./EditPlantDashboardHeaderTranslations.vue?vue&type=template&id=3ba37fcc"
import script from "./EditPlantDashboardHeaderTranslations.vue?vue&type=script&lang=js"
export * from "./EditPlantDashboardHeaderTranslations.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__